import { render } from "./AppIcon.vue?vue&type=template&id=385b99ee&bindings={\"name\":\"props\",\"size\":\"props\",\"color\":\"props\",\"title\":\"props\",\"desc\":\"props\",\"path\":\"options\",\"styleClasses\":\"options\"}"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"
script.render = render

export default script